import { useEffect, useState } from "react";

const tarjetas = [
    {
      title: "Startup SaaS",
      price: "1,5M €",
      description: "Plataforma B2B con más de 10.000 usuarios activos.",
    },
    {
      title: "Comprador: Gabriel S.",
      price: "Rango: 1M – 5M €",
      description: "Fondos verificados: 2,3M € • 7 adquisiciones completadas.",
    },
    {
      title: "Asesor M&A: Christian S.",
      price: "Especialista en SaaS",
      description: "Acompañamiento en procesos de compraventa y escalado.",
    },
  ];
  

export default function AnimatedDealFlow() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // comienza fade-out
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % tarjetas.length);
        setFade(true); // luego fade-in
      }, 300);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const tarjeta = tarjetas[index];

  return (
    <div
      className={`transition-all duration-500 ease-in-out max-w-md w-full px-6 py-5
        bg-white/70 backdrop-blur-md rounded-xl shadow-md text-center mt-6 border border-yellow-100
        ${fade ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}
    >
      <h3 className="text-lg font-semibold text-gray-800">{tarjeta.title}</h3>
      <p className="text-2xl font-bold text-yellow-500 mt-1">{tarjeta.price}</p>
      <p className="text-sm text-gray-700 mt-2">{tarjeta.description}</p>
    </div>
  );
}
